import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { ListarClinicas } from "../../Service/Serive.clinica";
import { ObtenerCompanies } from "../../Service/Service.compania";
import { CreaDoctor } from "../../Service/Service.doctor";
//Agregado para mostrar solo las espcialidades de la clinica...
import { GetEspecialidades, EspecialidadClinica } from "../../Service/Service.especialidad";
import { SubirMedia } from "../../Service/ServiceExternal";
import { GetTokenDecoded } from "../../utils/storeUsuario";
import Alert from "../Alert/Alert";
import Swal from "sweetalert2";
import SelectSearchble from "../SelectSeachble/SelectSearchble";
//generos
import { TipoGenero } from "../../Service/Service.genero";
import { ListarTipoDocumento } from "../../Service/Service.tipoDocumento";
import { ValidarCantidadDoctores } from "../../Service/Service.doctor";
export default function DoctorCreate({ handleClose, setPing, ping, editDoctor }) {

  const [alertclini, setAlertClini] = useState(false)
  const [alertEspec, setAlertEspec] = useState(false)
  const [alertCompany, setAlertCompany] = useState(false)
  const [clinics, setClinics] = useState([]);
  const refDiv = useRef(null)
  const [specialities, setSpecialities] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [send, setSend] = useState(false)
  const [alertType, setAlertType] = useState('')
  const [msj, setMsj] = useState('')
  const [selectedOptionClinica, setSelectedOptionClinica] = useState(null);
  const [selectedOptionCompany, setSelectedOptionCompany] = useState(null);
  const [listCompany, setListCompany] = useState([])
  const [foto, setFoto] = useState(null)
  const [sello, setSello] = useState(null)
  const [selectedOptionGenero, setselectedOptionGenero] = useState(null);
  //const { register, setValue, handleSubmit, formState: { errors } } = useForm();

  const {
    register,
    setValue,
    reset,
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: {
      lunes: true,
      martes: true,
      miercoles: true,
      jueves: true,
      viernes: true,
      sabado: false,
      domingo: false,
      activo: true,
      vacaciones: false,
      intervalo_tiempo: 15,
      // otros valores que necesites...
    }
  });
  
  
  const diasLaborales = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
  
  const [generos, setGeneros] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewImageSello, setPreviewImageSello] = useState(null);
  const [tipoDocumentos, setTipoDocumentos] = useState([]);
  const [selectedOptionDocumento, setSelectedOptionDocumento] = useState(null);
  const [statusCedula, setStatusCedula] = useState(true);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleFileChangeSello = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPreviewImageSello(URL.createObjectURL(file));
    }
  };


  // establecer los valores por default
  useEffect(() => {
    (async () => {
      const espec = await EspecialidadClinica(GetTokenDecoded().idclinica)
      if (espec) {
        setSpecialities(espec.data.map(e => ({ value: e.idespecialidad, label: e.especialidad })))
      }

      const clin = await ListarClinicas()
      if (clin) {
        setClinics(clin.map(c => ({ value: c.idclinica, label: c.nombre })))
      }

      const compay = await ObtenerCompanies()
      if (compay) {
        setListCompany(compay.map(c => ({ value: c.idcompany, label: c.company })))
      }

      const genero = await TipoGenero();
      if (genero) {
        setGeneros(genero.data.map(c => ({ value: c.genero, label: c.genero })))
      }

      const documentos = await ListarTipoDocumento();
      if (documentos.success) {
        setTipoDocumentos(documentos.data.map( d => ({value: d.idtipodocumento, label:d.tipo}) ))
      }
    })();
  }, []);

  const handleChange = (options) => {
    setSelectedOption(options); // opciones múltiples
    setAlertEspec(false);
  };
  const handleChangeClinica = selectedOptionClinica => {
    setSelectedOptionClinica(selectedOptionClinica);
    setAlertClini(false)
  };
  const handleChangeCompany = selectedOptionCompany => {
    setSelectedOptionCompany(selectedOptionCompany);
    setAlertCompany(false)
  };

  const handleChangeGenero = selectedOptionGenero => {
    setselectedOptionGenero(selectedOptionGenero);
    setAlertCompany(false)
  };

  const handleChangeDocumento = selectedOptionDocumento => {
    setSelectedOptionDocumento(selectedOptionDocumento);
    setAlertCompany(false)
    setStatusCedula(false);
  };

  // useEffect(() => {
  //   if (editDoctor != null) {
  //     const dias = editDoctor.doctors_dias_laborables?.[0] || {};
  //     alert("editando");
  //     alert(JSON.stringify(editDoctor));
  //     reset({
  //       iddoctor: editDoctor.iddoctor,
  //       prefijo: editDoctor.prefijo || '',
  //       nombre: editDoctor.nombre || '',
  //       cedula: editDoctor.cedula || '',
  //       telefono: editDoctor.telefono || '',
  //       celular: editDoctor.celular || '',
  //       email: editDoctor.email || '',
  //       titulo: editDoctor.titulo || '',
  //       idespecialidad: editDoctor.idespecialidad,
  //       genero: editDoctor.genero,
  //       idclinica: editDoctor.idclinica,
  //       idcompany: editDoctor.idcompany,
  //       intervalo_tiempo: editDoctor.intervalo_tiempo ?? 15,
  //       horario_inicio: editDoctor.horario_inicio || '',
  //       horario_fin: editDoctor.horario_fin || '',
  //       activo: editDoctor.activo ?? true,
  //       vacaciones: editDoctor.vacaciones ?? false,
  //       fecha_nac: editDoctor.fecha_nac?.split('T')[0] || '',
  //       calcolor: editDoctor.calcolor || '#ffffff',
  //       registro: editDoctor.registro || '',
  //       tipoID: editDoctor.tipoID || '',
  //       consultorio: editDoctor.consultorio || '',
  //       drprefijo: editDoctor.drprefijo || '',
  //       lunes: dias.lunes ?? true,
  //       martes: dias.martes ?? true,
  //       miercoles: dias.miercoles ?? true,
  //       jueves: dias.jueves ?? true,
  //       viernes: dias.viernes ?? true,
  //       sabado: dias.sabado ?? false,
  //       domingo: dias.domingo ?? false,
  //     });
  
  //     setFoto(editDoctor.foto);
  //     setSello(editDoctor.sello);
  //     if (editDoctor.doctor_especialidades?.length > 0) {
  //       const especialidades = editDoctor.doctor_especialidades.map(e => ({
  //         value: e.idespecialidad,
  //         label: e.especialidad?.especialidad || `ID ${e.idespecialidad}`,
  //       }));
  //       setSelectedOption(especialidades);
  //     }
  //     setSelectedOptionClinica({
  //       value: editDoctor.clinica.idclinica,
  //       label: editDoctor.clinica.nombre,
  //     });
  //     setSelectedOptionCompany({
  //       value: editDoctor.compania.idcompany,
  //       label: editDoctor.compania.company,
  //     });
  //     setselectedOptionGenero({
  //       value: editDoctor.genero,
  //       label: editDoctor.genero,
  //     });
  
  //     if (editDoctor.tipo_documentos) {
  //       setSelectedOptionDocumento({
  //         value: editDoctor.tipo_documentos.idtipodocumento,
  //         label: editDoctor.tipo_documentos.tipo,
  //       });
  //       setStatusCedula(false);
  //     }
  //   } else {
  //     reset({
  //       lunes: true,
  //       martes: true,
  //       miercoles: true,
  //       jueves: true,
  //       viernes: true,
  //       sabado: false,
  //       domingo: false,
  //       vacaciones: false,
  //       activo: true,
  //       intervalo_tiempo: 15,
  //     });
  //   }
  // }, []);
  useEffect(() => {
    if (editDoctor && specialities.length > 0) {
      //const dias = editDoctor.doctors_dias_laborables?.[0] || {};
      const dias = editDoctor.doctors_dias_laborables || {};
  
      reset({
        iddoctor: editDoctor.iddoctor,
        prefijo: editDoctor.prefijo || '',
        nombre: editDoctor.nombre || '',
        cedula: editDoctor.cedula || '',
        telefono: editDoctor.telefono || '',
        celular: editDoctor.celular || '',
        email: editDoctor.email || '',
        titulo: editDoctor.titulo || '',
        idespecialidad: editDoctor.idespecialidad,
        genero: editDoctor.genero,
        idclinica: editDoctor.idclinica,
        idcompany: editDoctor.idcompany,
        intervalo_tiempo: editDoctor.intervalo_tiempo ?? 15,
        horario_inicio: editDoctor.horario_inicio || '',
        horario_fin: editDoctor.horario_fin || '',
        activo: editDoctor.activo ?? true,
        vacaciones: editDoctor.vacaciones ?? false,
        fecha_nac: editDoctor.fecha_nac?.split('T')[0] || '',
        calcolor: editDoctor.calcolor || '#ffffff',
        registro: editDoctor.registro || '',
        tipoID: editDoctor.tipoID || '',
        consultorio: editDoctor.consultorio || '',
        drprefijo: editDoctor.drprefijo || '',
        lunes: dias.lunes ?? true,
        martes: dias.martes ?? true,
        miercoles: dias.miercoles ?? true,
        jueves: dias.jueves ?? true,
        viernes: dias.viernes ?? true,
        sabado: dias.sabado ?? false,
        domingo: dias.domingo ?? false,
      });
  
      setFoto(editDoctor.foto);
      setSello(editDoctor.sello);
  
      // ✅ ESTO ES LO CLAVE
      if (editDoctor.doctor_especialidades?.length > 0) {
        const especialidades = editDoctor.doctor_especialidades
          .filter(e => e && e.idespecialidad)
          .map(e => {
            const match = specialities.find(s => s.value === e.idespecialidad);
            return match || {
              value: e.idespecialidad,
              label: e?.especialidad?.especialidad ?? `ID ${e?.idespecialidad ?? 'Desconocida'}`
            };
          });
      
        setSelectedOption(especialidades);
      }
      
  
      setSelectedOptionClinica({
        value: editDoctor.clinica.idclinica,
        label: editDoctor.clinica.nombre,
      });
  
      setSelectedOptionCompany({
        value: editDoctor.compania.idcompany,
        label: editDoctor.compania.company,
      });
  
      setselectedOptionGenero({
        value: editDoctor.genero,
        label: editDoctor.genero,
      });
  
      if (editDoctor.tipo_documentos) {
        setSelectedOptionDocumento({
          value: editDoctor.tipo_documentos.idtipodocumento,
          label: editDoctor.tipo_documentos.tipo,
        });
        setStatusCedula(false);
      }
    }
  }, [editDoctor, specialities]); // <- Agregado `specialities` como dependencia
  

  const onSubmit = handleSubmit(async (data) => {
    // ✅ Validaciones de selects
    if (!selectedOption) {
      setAlertClini(true);
      return;
    }
    if (!selectedOptionClinica) {
      setAlertEspec(true);
      return;
    }
  
    // ✅ Company
    if (selectedOptionCompany) {
      data["idcompany"] = selectedOptionCompany.value;
    } else {
      data["idcompany"] = GetTokenDecoded().idcompany;
    }
  
    // ✅ Si es edición
    if (editDoctor) {
      data["iddoctor"] = editDoctor.iddoctor;
    }

    // ORDENES-IMPRIMIR-01: sin sello el doctor no puede imprimir recetas ni
    // órdenes (el PDF lo exige). Ya pasó que subieran la firma en "Foto".
    const subeSello = data.sello && data.sello.length > 0 && data.sello[0];
    if (!subeSello && !sello) {
      const r = await Swal.fire({
        icon: "warning",
        title: "El doctor queda sin sello / firma",
        text: "Sin sello no podrá imprimir recetas ni órdenes. La firma va en el campo «Sello / Firma», no en «Foto de perfil».",
        showCancelButton: true,
        confirmButtonText: "Guardar sin sello",
        cancelButtonText: "Volver y subir el sello",
        reverseButtons: true,
      });
      if (!r.isConfirmed) return;
    }

    // ✅ Empezamos envío
    setSend(true);
  
    // =========================================================
    // 🔒 VALIDAR LIMITE DE DOCTORES (crear / activar)
    // =========================================================
    try {
      // el checkbox te puede llegar como true/false o "true"/"false"
      const quiereActivo = data.activo === true || data.activo === "true";
  
      // ✅ CREAR: si quiere crear activo → valida
      if (!editDoctor && quiereActivo) {
        const validacion = await ValidarCantidadDoctores();
  
        if (!validacion?.puede_crear) {
          Swal.fire({
            title:
              "Su Compañia ha alcanzado el límite de usuarios de acuerdo a su plan.. Contactese al: 0995652112",
            text: validacion?.message || "Límite alcanzado",
            icon: "warning",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#3085d6",
          });
          setSend(false);
          return;
        }
      }
  
      // ✅ EDITAR: solo si estaba inactivo y ahora lo quiere activar → valida
      if (editDoctor) {
        const antesActivo =
          editDoctor.activo === true || editDoctor.activo === 1;
  
        if (!antesActivo && quiereActivo) {
          const validacion = await ValidarCantidadDoctores();
  
          if (!validacion?.puede_crear) {
            Swal.fire({
              title:
                "Su Compañia ha alcanzado el límite de usuarios de acuerdo a su plan.. Contactese al: 0995652112",
              text: validacion?.message || "Límite alcanzado",
              icon: "warning",
              confirmButtonText: "Entendido",
              confirmButtonColor: "#3085d6",
            });
            setSend(false);
            return;
          }
        }
      }
    } catch (error) {
      console.error("Error validando límite de doctores:", error);
      Swal.fire("Error", "No se pudo verificar el límite de doctores", "error");
      setSend(false);
      return;
    }
  
    // =========================================================
    // 📷 Subida de archivos (foto / sello)
    // =========================================================
    if (data.foto && data.foto.length > 0 && data.foto[0]) {
      const url = await SubirMedia(data.foto[0], null, null, 0, "foto_doctor");
      data.foto = url;
    } else {
      data.foto = foto;
    }
  
    if (data.sello && data.sello.length > 0 && data.sello[0]) {
      const url = await SubirMedia(data.sello[0], null, null, 0, "sello_doctor");
      data.sello = url;
    } else {
      data.sello = sello;
    }
  
    // =========================================================
    // ✅ Campos extra
    // =========================================================
    data["idclinica"] = selectedOptionClinica.value;
    data["genero"] = selectedOptionGenero.value;
    data["tipo_documento"] = selectedOptionDocumento.value;
  
    data["dias_laborales"] = {
      lunes: data.lunes,
      martes: data.martes,
      miercoles: data.miercoles,
      jueves: data.jueves,
      viernes: data.viernes,
      sabado: data.sabado,
      domingo: data.domingo,
    };
  
    // ✅ Especialidades (multi)
    data.especialidades = (selectedOption || []).map((opt) => ({
      idespecialidad: opt.value,
      idclinica: selectedOptionClinica?.value || GetTokenDecoded().idclinica,
    }));
  
    // =========================================================
    // 🚀 Guardar
    // =========================================================
    const response = await CreaDoctor(data);
    // HM-06: EditarDoctor sigue devolviendo un booleano; sólo la creación
    // devuelve un objeto (con la posible contraseña temporal).
    const ok = typeof response === "object" ? response?.success : response;

    if (ok) {
      setAlertType("success");
    } else {
      setAlertType("error");
    }

    // HM-06: mostrar la contraseña temporal una única vez — el backend no
    // la vuelve a exponer en ninguna otra respuesta.
    if (!editDoctor && response?.passwordTemporal) {
      await Swal.fire({
        icon: "success",
        title: "Doctor creado",
        html: `Contraseña temporal (comunicarla al doctor, no se mostrará de nuevo):<br/><b style="font-size:1.2em">${response.passwordTemporal}</b>`,
        confirmButtonText: "Entendido",
      });
    }

    setSend(false);
    refDiv.current.scrollIntoView({ behavior: "smooth" });

    setTimeout(() => {
      setAlertType("");
      setPing(!ping);
      handleClose();
    }, 800);
  });
  const onSubmit05032026 = handleSubmit(async (data) => {
    
    if (!selectedOption) {
      setAlertClini(true)
      return;
    }
    if (!selectedOptionClinica) {
      setAlertEspec(true)
      return;
    }

    if (selectedOptionCompany) {
      data['idcompany'] = selectedOptionCompany.value
    } else {
      data['idcompany'] = GetTokenDecoded().idcompany
    }

    if (editDoctor) {
      data['iddoctor'] = editDoctor.iddoctor
    }
    setSend(true)

    if (data.foto && data.foto.length > 0 && data.foto[0]) {
      const url = await SubirMedia(data.foto[0], null, null, 0, 'foto_doctor');
      data.foto = url;
    } else {
      data.foto = foto
    }

    if (data.sello && data.sello.length > 0 && data.sello[0]) {
      const url = await SubirMedia(data.sello[0], null, null, 0, 'sello_doctor');
      data.sello = url;
    } else {
      data.sello = sello
    }
    //data['idespecialidad'] = selectedOption.value
    data['idclinica'] = selectedOptionClinica.value
    data['genero'] = selectedOptionGenero.value
    data['tipo_documento'] = selectedOptionDocumento.value

    data['dias_laborales'] = {
      lunes: data.lunes,
      martes: data.martes,
      miercoles: data.miercoles,
      jueves: data.jueves,
      viernes: data.viernes,
      sabado: data.sabado,
      domingo: data.domingo
    }

    // Guardar especialidades seleccionadas como array de objetos
    data.especialidades = (selectedOption || []).map(opt => ({
      idespecialidad: opt.value,
      idclinica: selectedOptionClinica?.value || GetTokenDecoded().idclinica
    }));
    const response = await CreaDoctor(data)
    if (response) {
      setAlertType('success')
    } else {
      setAlertType('error')
    }
    setSend(false)
    refDiv.current.scrollIntoView({ behavior: 'smooth' })
    setTimeout(() => {
      setAlertType('')
      setPing(!ping)
      handleClose()
    }, 800);
  })

  const ImagePreview = ({ label, src }) => (
    <div className="me-3" style={{ width: '100px', height: '100px' }}>
      <span>{label}</span>
      <img src={src} alt={label} className="img-fluid mt-2" style={{ width: '100px', height: '100px' }} />
    </div>
  );

  return (
    
    <section>
      <Alert
        tipo_alert={msj || alertType}
        type={msj || alertType}
      />
      <div className="row">
        <div
          ref={refDiv}
        />
        <div className="col-12">
          <div className="card">
            <div className="card-body">

              <form id="form-create-doctor" onSubmit={onSubmit}>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Especialidad *</label>
                  <div className="col-sm-9">
                  <SelectSearchble
                    listCompany={specialities}
                    handleChange={handleChange}
                    selectedOption={selectedOption}
                    placeholder="Seleccione especialidad(es)"
                    isMulti={true}
                  />
                    <Alert
                      tipo_alert="danger"
                      type={alertEspec ? 'select' : ''}
                    />
                  </div>
                </div>

                {
                  GetTokenDecoded().idcompany === 0 ?
                    (
                      <div className="row mb-4">
                        <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Compania *</label>
                        <div className="col-sm-9">
                          <SelectSearchble
                            listCompany={listCompany}
                            handleChange={handleChangeCompany}
                            selectedOption={selectedOptionCompany}
                            placeholder="Seleccione compania"
                            isMulti={false}
                          />
                          <Alert
                            tipo_alert="danger"
                            type={alertCompany ? 'select' : ''}
                          />
                        </div>
                      </div>
                    )
                    : null
                }

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Clinica *</label>
                  <div className="col-sm-9">
                    <SelectSearchble
                      listCompany={clinics}
                      handleChange={handleChangeClinica}
                      selectedOption={selectedOptionClinica}
                      placeholder="Seleccione clinica"
                      isMulti={false}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={alertclini ? 'select' : ''}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Prefijo*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" id="Prefijo" name="Prefijo"
                      {...register('prefijo', {
                        required: true,
                        maxLength: 5,
                        // pattern: /^[A-Z0-9]*$/i
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.prefijo?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Nombre*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('nombre', {
                        required: true,
                        maxLength: 50,
                        minLength: 5
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.nombre?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Tipo de Documento *</label>
                  <div className="col-sm-9">
                    <SelectSearchble
                      listCompany={tipoDocumentos}
                      handleChange={handleChangeDocumento}
                      selectedOption={selectedOptionDocumento}
                      placeholder="Seleccione tipo"
                      isMulti={false}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={alertclini ? 'select' : ''}
                    />
                  </div>
                </div>                

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Cedula*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control" disabled={statusCedula}
                      {...register('cedula', {
                        required: true,
                        maxLength: 13,
                        pattern: /^[0-9]*$/i,
                        minLength: 10
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.cedula?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Telefono</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('telefono', {
                        required: false,
                        maxLength: 10,
                        pattern: /^[0-9]*$/i,
                        minLength: 7
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.telefono?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Celular*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('celular', {
                        required: true,
                        maxLength: 12,
                        pattern: /^[0-9]*$/i,
                        minLength: 10
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.celular?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Email*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('email', {
                        required: true,
                        maxLength: 50,
                        pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                        minLength: 8
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.email?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Titulo*</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('titulo', {
                        required: true,
                        maxLength: 50,
                        minLength: 5
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.titulo?.type}
                    />
                  </div>
                </div>

                {/* combo de genero Inicio */}

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Genero *</label>
                  <div className="col-sm-9">
                    <SelectSearchble
                      listCompany={generos}
                      handleChange={handleChangeGenero}
                      selectedOption={selectedOptionGenero}
                      placeholder="Seleccione genero"
                      isMulti={false}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={alertEspec ? 'select' : ''}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Intervalo de atencion</label>
                  <div className="col-sm-9">
                    <input type="number" className="form-control"
                      {...register('intervalo_tiempo', {
                        required: false,
                        maxLength: 60,
                        pattern: /^[0-9]*$/i,
                        minLength: 1,
                        defaultValue: 15,
                      })}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Horario*</label>
                  <div className="col-sm-4">
                    <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Inicio</label>
                    <input type="time" className="form-control"
                      {...register('horario_inicio', { required: true })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.horario_inicio?.type}
                    />
                  </div>
                  <div className="col-sm-4">
                    <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Fin</label>
                    <input type="time" className="form-control"
                      {...register('horario_fin', { required: true })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.horario_fin?.type}
                    />
                  </div>
                </div>

                {/* foto */}
                <div className="row mb-4">
                  <label htmlFor="foto" className="col-sm-3 col-form-label">Foto de perfil</label>
                  <div className="col-sm-9">
                    <input 
                      type="file" 
                      className="form-control" 
                      name="foto" 
                      id="foto"
                      {...register('foto', {
                        required: false,
                        pattern: /\.(jpe?g|png)$/i,
                        // dentro de register: un onChange suelto después del
                        // spread pisa el de react-hook-form
                        onChange: handleFileChange,
                      })}
                    />

                    <Alert
                      tipo_alert="danger"
                      type={errors.foto?.type}
                    />
                    {/* Vista previa de imágenes */}
                    {(editDoctor?.foto || previewImage) && (
                      <div className="d-flex justify-content-start align-items-center">
                        {editDoctor?.foto && <ImagePreview label="Imagen actual" src={editDoctor.foto} />}
                        {previewImage && <ImagePreview label="Nueva imagen" src={previewImage} />}
                      </div>
                    )}
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Estado</label>
                  <div className="col-sm-9">
                    <div className="form-check form-switch form-switch-md mb-3" dir="ltr">
                      <input type="checkbox" className="form-check-input"
                        {...register('activo', {
                          required: false,
                          defaultValue: true
                        })}
                      />
                    </div>
                    <Alert
                      tipo_alert="danger"
                      type={errors.activo?.type}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Vacaciones</label>
                  <div className="col-sm-9">
                    <div className="form-check form-switch form-switch-md mb-3" dir="ltr">
                      <input type="checkbox" className="form-check-input"
                        {...register('vacaciones', {
                          required: false,
                          defaultValue: false,
                        })}
                      />
                    </div>
                    <Alert
                      tipo_alert="danger"
                      type={errors.vacaciones?.type}
                    />
                  </div>
                </div>

                {/* sello */}
                <div className="row mb-4">
                  <label htmlFor="sello" className="col-sm-3 col-form-label">Sello / Firma</label>
                  <div className="col-sm-9">
                    <input
                      type="file"
                      className="form-control" 
                      name="sello" 
                      id="sello"
                      {...register("sello", {
                        required: false,
                        pattern: /\.(jpe?g|png)$/i,
                        onChange: handleFileChangeSello,
                      })}
                    />
                    <small className="text-muted d-block mt-1">
                      Es la firma que se imprime en recetas y órdenes. Sin sello el doctor no puede imprimirlas.
                    </small>
                    <Alert 
                      tipo_alert="danger" 
                      type={errors.sello?.type} />

                    {/* Vista previa de imágenes */}
                    {(editDoctor?.sello || previewImageSello) && (
                      <div className="d-flex justify-content-start align-items-center">
                        {editDoctor?.sello && <ImagePreview label="Imagen actual" src={editDoctor.sello} />}
                        {previewImageSello && <ImagePreview label="Nueva imagen" src={previewImageSello} />}
                      </div>
                    )}

                  </div>
                </div>


                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Fecha nacimiento</label>
                  <div className="col-sm-9">
                    <input type="date" className="form-control"
                      {...register('fecha_nac', { required: false })}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Cal Color</label>
                  <div className="col-sm-2">
                    <input type="color" className="form-control"
                      {...register('calcolor', {
                        required: false,
                        defaultValue: '#ffffff'
                      })}
                    />
                  </div>
                </div>

                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Registro</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('registro', {
                        required: false,
                        maxLength: 160,
                        pattern: /^[A-Z0-9-]*$/i,
                        defaultValue: ''
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.registro?.type}
                    />

                  </div>
                </div>

                {/*inicio consultorio y drprefijo */}
                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Consultorio</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('consultorio', {
                        required: false,
                        maxLength: 160,
                        pattern: /^[A-Z0-9-]*$/i,
                        defaultValue: ''
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.registro?.type}
                    />

                  </div>
                </div>
                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Prefijo Turnero</label>
                  <div className="col-sm-9">
                    <input type="text" className="form-control"
                      {...register('drprefijo', {
                        required: false,
                        maxLength: 160,
                        pattern: /^[A-Z0-9-]*$/i,
                        defaultValue: ''
                      })}
                    />
                    <Alert
                      tipo_alert="danger"
                      type={errors.registro?.type}
                    />

                  </div>
                </div>
                {/*fin consultorio y drprefijo */}
                <div className="row mb-4">
                  <label htmlFor="horizontal-firstname-input" className="col-sm-3 col-form-label">Días laborales</label>
                  <div className="col-sm-9">
                    <div className="row">
                      {diasLaborales.map((dia) => (
                        <div className="col-sm-3" key={dia}>
                          <Controller
                            name={dia}
                            control={control}
                            render={({ field }) => (
                              <div className="form-check form-switch form-switch-md mb-3" dir="ltr">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id={`switch-${dia}`}
                                  checked={!!field.value}
                                  onChange={(e) => field.onChange(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor={`switch-${dia}`}>
                                  {dia.charAt(0).toUpperCase() + dia.slice(1)}
                                </label>
                              </div>
                            )}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>



                <div className="text-center">
                  <button onClick={handleClose} type="button" className="btn btn-danger m-1">Cancelar</button>
                  <button type="submit" className="btn btn-primary ">{editDoctor ? 'Actualizar' : 'Crear'}</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>


    </section>
  );
}
